/* ==========================================================================
   Rook UI Core — Quantity Selector Controller
   Web Component: <rk-quantity-selector>
   ========================================================================== */

import { RkComponent } from '@rook/component';

class RkQuantitySelector extends RkComponent {
    static hydration = 'eager';

    setup() {
        this.input = this.querySelector('.rk-quantity__input');
        this.btnMinus = this.querySelector('[data-type="minus"]');
        this.btnPlus = this.querySelector('[data-type="plus"]');

        if (!this.input) return;

        this.delegate({
            'click [data-type="minus"]': () => this.step(-1),
            'click [data-type="plus"]': () => this.step(1),
            'change .rk-quantity__input': this.onChange,
            'keydown .rk-quantity__input': this.onKeyDown,
        });

        this.updateButtons();
    }

    onChange() {
        this.clampValue();
        this.updateButtons();
        this.dispatchChange();
    }

    onKeyDown(event) {
        if (['e', 'E', '+', '-', '.', ','].includes(event.key)) {
            event.preventDefault();
        }
    }

    step(direction) {
        const stepValue = parseInt(this.input.step) || 1;
        const current = parseInt(this.input.value) || 1;
        const newValue = current + (stepValue * direction);

        this.input.value = newValue;
        this.clampValue();
        this.updateButtons();
        this.dispatchChange();
    }

    clampValue() {
        const min = parseInt(this.input.min) || 1;
        const max = this.input.max ? parseInt(this.input.max) : Infinity;
        let value = parseInt(this.input.value) || min;
        value = Math.max(min, Math.min(max, value));
        this.input.value = value;
    }

    updateButtons() {
        const value = parseInt(this.input.value) || 1;
        const min = parseInt(this.input.min) || 1;
        const max = this.input.max ? parseInt(this.input.max) : Infinity;

        if (this.btnMinus) this.btnMinus.disabled = value <= min;
        if (this.btnPlus) this.btnPlus.disabled = value >= max;
    }

    dispatchChange() {
        this.rkEmit('quantity:change', {
            value: parseInt(this.input.value),
            name: this.input.name,
        });
    }
}

if (!customElements.get('rk-quantity-selector')) {
    customElements.define('rk-quantity-selector', RkQuantitySelector);
}
